import React, { useContext, useState } from "react";
import { useLocation } from "react-router";
import { TriangleAlert } from "lucide-react";
import { AuthContext, IntlContext } from "context";
import { useLoginDialog } from "context/LoginDialog";
import { Button } from "components/ui/button";
import { useReportAdStatus } from "hooks/reportAd";
import ReportAdDialog from "./ReportAdDialog";

type ReportAdButtonProps = {
    adId: string;
};

const ReportAdButton: React.FC<ReportAdButtonProps> = ({ adId }) => {
    const intl = useContext(IntlContext);
    const { isLoggedIn } = useContext(AuthContext);
    const { actions: { openLogin } } = useLoginDialog();
    const location = useLocation();
    const [open, setOpen] = useState(false);
    const statusQuery = useReportAdStatus(adId, Boolean(isLoggedIn));
    const hasReported = Boolean(statusQuery.data?.has_reported);
    const title = hasReported
        ? intl.formatMessage("ad.view.report_already")
        : intl.formatMessage("ad.view.report");

    const handleClick = () => {
        if (!isLoggedIn) {
            openLogin(`${location.pathname}${location.search}`);
            return;
        }

        setOpen(true);
    };

    return (
        <>
            <Button
                type="button"
                variant="ghost"
                size="icon"
                className="w-12 h-12 rounded-[14px] bg-slate-50 border border-[#f1f5f9] hover:bg-[#f1f5f9] flex items-center justify-center text-[#5a607c] transition focus-visible:ring-[#5a607c]"
                title={title}
                aria-label={title}
                disabled={hasReported}
                onClick={handleClick}
            >
                <TriangleAlert className="w-5 h-5" aria-hidden="true" />
            </Button>
            <ReportAdDialog adId={adId} open={open} onOpenChange={setOpen} />
        </>
    );
};

export default ReportAdButton;
